import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.scss';
import { AuthProvider } from './auth/AuthContext';
import Router from './components/Router/Router';
import { FormConfigProvider } from './context/FormConfigContext';
import { UiProvider } from './context/UiContext';
import { isDev } from './utils/env-utils';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: console.error,
  }),
  defaultOptions: { queries: { staleTime: 1000 } },
});

root.render(
  <React.StrictMode>
    <FormConfigProvider configName={process.env.REACT_APP_FORM_CONFIG || 'csc'}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <UiProvider>
            <BrowserRouter>
              <Router />
            </BrowserRouter>
          </UiProvider>
          {!!isDev && <ReactQueryDevtools initialIsOpen={false} />}
        </AuthProvider>
      </QueryClientProvider>
    </FormConfigProvider>
  </React.StrictMode>,
);
